import { Grid2 as Grid } from '@mui/material';
import { OrderCardTextItem } from '../../../../components';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { WhatsAppButton } from '../../../../components/WhatsAppButton';

export function CrossdockingOrderCardExpand({
  addressDetail,
  ecommerceName,
  lastUpdate,
  phoneNumber,
  unAvailable,
}) {
  const { t } = useTranslation(['description']);

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <OrderCardTextItem
          label={t('orders.warecloud.address_detail', { ns: 'description' })}
          description={addressDetail}
          disabled={unAvailable}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <OrderCardTextItem
          label={t('orders.ecommerce.name', { ns: 'description' })}
          description={ecommerceName}
          disabled={unAvailable}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <OrderCardTextItem
          label={t('orders.last_update', { ns: 'description' })}
          description={dayjs(lastUpdate).format('DD/MM/YYYY HH:mm')}
          disabled={unAvailable}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <WhatsAppButton
          phoneNumber={phoneNumber}
          label={t('orders.warecloud.contact', { ns: 'description' })}
        />
      </Grid>
    </Grid>
  );
}
